module.exports = __webpack_public_path__ + "img/kursi.0b4f671a.png";